import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilter = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 3,
			y: 5,
			width: 3,
			height: 1,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 3,
			height: 1,
			transform: "matrix(-1 0 0 1 15 12)",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 8,
			y: 5,
			width: 7,
			height: 1,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 7,
			height: 1,
			transform: "matrix(-1 0 0 1 10 12)",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8 5.5C8 4.94772 7.55228 4.5 7 4.5C6.44772 4.5 6 4.94772 6 5.5C6 6.05228 6.44772 6.5 7 6.5V7.5C5.89543 7.5 5 6.60457 5 5.5C5 4.39543 5.89543 3.5 7 3.5C8.10457 3.5 9 4.39543 9 5.5C9 6.60457 8.10457 7.5 7 7.5V6.5C7.55228 6.5 8 6.05228 8 5.5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10 12.5C10 11.9477 10.4477 11.5 11 11.5C11.5523 11.5 12 11.9477 12 12.5C12 13.0523 11.5523 13.5 11 13.5V14.5C12.1046 14.5 13 13.6046 13 12.5C13 11.3954 12.1046 10.5 11 10.5C9.89543 10.5 9 11.3954 9 12.5C9 13.6046 9.89543 14.5 11 14.5V13.5C10.4477 13.5 10 13.0523 10 12.5Z",
			fill: "currentColor"
		})
	]
});
export default SvgFilter;
